module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MUSIC-262f86ccb6f7592ddd44800667447f59.png";